/** How the advance amount was entered; `amount` is always the resolved rupee value. */
export enum EmployeeAdvanceValueType {
  FIXED = "FIXED",
  PERCENTAGE = "PERCENTAGE",
}

export const EmployeeAdvanceValueTypeLabel: Record<
  EmployeeAdvanceValueType,
  string
> = {
  [EmployeeAdvanceValueType.FIXED]: "Fixed (₹)",
  [EmployeeAdvanceValueType.PERCENTAGE]: "Percentage (%)",
};

export enum EmployeeAdvanceStatus {
  /** Created; not yet disbursed. No Payment exists yet — call disburse() to attach one. */
  DRAFT = "DRAFT",
  /** Disbursed. May be partially settled — check settledAmount/settleableAmount, there's no separate "partially settled" status. */
  PROCESSED = "PROCESSED",
  SETTLED = "SETTLED",
  CANCELLED = "CANCELLED",
  /** Full remaining (un-settled) balance refunded — no partial refunds. */
  REFUNDED = "REFUNDED",
}

export const employeeAdvanceStatusMap: Record<
  EmployeeAdvanceStatus,
  { label: string; color: string; hint?: string }
> = {
  [EmployeeAdvanceStatus.DRAFT]: {
    label: "Awaiting Disbursement",
    color: "info",
    hint: "Recorded but not yet disbursed — no payment exists yet.",
  },
  [EmployeeAdvanceStatus.PROCESSED]: {
    label: "Processed",
    color: "success",
    hint: "Disbursed — may be fully or partially settled; see settled/settleable amounts.",
  },
  [EmployeeAdvanceStatus.SETTLED]: {
    label: "Settled",
    color: "primary",
    hint: "Fully settled — nothing outstanding.",
  },
  [EmployeeAdvanceStatus.CANCELLED]: {
    label: "Cancelled",
    color: "danger",
    hint: "Cancelled — this advance is no longer active.",
  },
  [EmployeeAdvanceStatus.REFUNDED]: {
    label: "Refunded",
    color: "dark",
    hint: "Full remaining balance was refunded by the employee.",
  },
};
